"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CloseIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.68743 18L0 16.3029L7.26151 9L0 1.69706L1.68743 0L9.00013 7.35443L16.3128 0L18.0003 1.69706L10.7388 9L18.0003 16.3029L16.3128 18L9.00013 10.6456L1.68743 18Z",
  fill: "#36424E"
}));

var _default = CloseIcon;
exports.default = _default;